module.exports = {
  defaultTitle: 'Ping Cheng',
  author: 'Ping Cheng',
  legalName: 'Ping Cheng',
  defaultDescription: 'Frontend Engineer',
  socialLinks: {
    github: 'https://github.com/aboudicheng',
    linkedin: 'https://www.linkedin.com/in/ping-cheng/',
    instagram: 'https://instagram.com/aboudicheng',
  },
  googleAnalyticsID: 'UA-78056630-2',
  themeColor: '#191E2C',
  backgroundColor: '#191E2C',
  contact: {
    email: 'aboudicheng@gmail.com',
  },
  recaptcha_key: '6LfZ-NQUAAAAAB-qzVB13PpOtweC6aETmwZqqe3r',
};
